<div class="wrap">

  <!-- <div class="header">
    <div class="title">
        <fa-icon [icon]="faChevronLeft" [routerLink]="['/admin']" routerLinkActive="router-link-active"></fa-icon>
        <h2>Liste des réductions</h2>
    </div>
  
    <div class="add_search_discount">
        <div class="add_discount" (click)="addOrEditDiscount('add', 'Ajouter', 'Réduction ajoutée')">
            <fa-icon [icon]="faPlus"></fa-icon>
            <span>Ajouter une réduction</span>
        </div>
        <div class="search_bar">
            <form [formGroup]="searchForm">
                <input type="text" placeholder="Chercher une réduction ..." (input)="applyFilter($event.target.value)"
                    formControlName="keyword">
            </form>
  
            <fa-icon [icon]="faTimes" (click)="resetSearch()" class="faTimes" *ngIf="valueInput"></fa-icon>
            <fa-icon [icon]="faSearch" *ngIf="!valueInput"></fa-icon>
  
        </div>
    </div>
  </div>

  <ng-container [ngSwitch]="userConnected.role">
      <app-admin-discount-club *ngSwitchCase="'club'" [searchInput]="valueInput"></app-admin-discount-club>
      <app-admin-discount-admin *ngSwitchCase="'admin'" ></app-admin-discount-admin>
  </ng-container> -->

  <div class="header">
    <div class="title">
        <fa-icon [icon]="getFaIcon('faChevronLeft')" [routerLink]="['/admin']" routerLinkActive="router-link-active" appChangeColorTheme attribute="color"></fa-icon>
        <h2>{{title}}</h2>
    </div>
  
    <div class="add_search_discount">
        <div class="add_discount" (click)="addOrEditDiscount('add')" appChangeColorTheme [isHover]="true">
            <fa-icon [icon]="getFaIcon('faPlus')" appChangeColorTheme attribute="color"></fa-icon>
            <span>Ajouter une réduction</span>
        </div>
        <div class="search_bar">
            <form [formGroup]="searchForm">
                <input type="text" placeholder="Chercher une réduction ..." (input)="applyFilter($event.target.value)"
                    formControlName="keyword">
            </form>
  
            <fa-icon [icon]="getFaIcon('faTimes')" (click)="resetSearch()" class="faTimes" *ngIf="valueInput" ></fa-icon>
            <fa-icon [icon]="getFaIcon('faSearch')" *ngIf="!valueInput"></fa-icon>
  
        </div>
    </div>
  </div>

  <app-admin-discount-club [searchInput]="valueInput"></app-admin-discount-club>


</div>